import instance from "@/services/api";

export const projectsEntryAPI = {
  async updProject(body, params) {
    return await instance()
      .post("/project_list/project/upd/", body, { params })
      .then((res) => res?.data);
  },
  async updProjectLimit(body, params) {
    return await instance()
      .post("/project_list/project/limit_upd/", body, { params })
      .then((res) => res?.data);
  },
  async getFlatWorkSets(project_id) {
    return await instance()
      .get(`/project_list/flat/work_sets/read/`, { params: { project_id } })
      .then((res) => res?.data);
  },
  async getFlatMaterials(project_id) {
    return await instance()
      .get(`/project_list/flat/materials/read/`, { params: { project_id } })
      .then((res) => res?.data);
  },
  async recalcProjectMaterialPrices(body) {
    return await instance()
      .post(`/project_list/flat/prices/recalc/`, body)
      .then((res) => res?.data);
  },
  async getSkladBySectionForeman(project_id) {
    return await instance()
      .get("/project_list/common/sklad/by_section_foreman/read/", { params: { project_id } })
      .then((res) => res?.data);
  },
  async updWriteoffInfo(body) {
    return await instance()
      .put("/project_list/project/writeoff_info/upd/", body)
      .then((res) => res?.data);
  },
  async getProjectInfo(project_id) {
    return await instance()
      .get(`/project_list/project/${project_id}/info/`)
      .then((res) => res?.data);
  },
  async updProjectInfo(body) {
    return await instance()
      .post(`/project_list/project/info_upd/`, body)
      .then((res) => res?.data);
  },
  async getEmployeeList() {
    return await instance()
      .get("/project_list/project/employee_list/")
      .then((res) => res?.data);
  },
  async getEntrancesBlockInfo(project_id) {
    return await instance()
      .get(`/project_list/project/${project_id}/blocks/`)
      .then((res) => res?.data);
  },
  async updEntrancesBlockInfo(body) {
    return await instance()
      .post(`/project_list/project/blocks_upd/`, body)
      .then((res) => res?.data);
  },
  async getPerformersByProjectId(project_id) {
    return await instance()
      .get(`/project_list/project/read_assign/project_id/${project_id}/`)
      .then((res) => res?.data);
  },
  async getAssignTypes() {
    return await instance()
      .get(`/project_list/project/assign_type/`)
      .then((res) => res?.data);
  },
  async getContractors() {
    return await instance()
      .get(`/project_list/contractors/read/`)
      .then((res) => res?.data);
  },
  async getEmployeesListByContractorId(contractor_id) {
    return await instance()
      .get(`/project_list/employees/contractor_id/${contractor_id}/`)
      .then((res) => res?.data);
  },
  async getProjectsById(project_id) {
    return await instance()
      .get(`/project_list/project/${project_id}/projects_resident/`)
      .then((res) => res?.data);
  },
  async updateShellProjectPerfomancer(body) {
    return await instance()
      .post("/project_list/project/assign_upd/", body)
      .then((res) => res?.data);
  },
  async copyPasteEntranceProperties(body, params) {
    return await instance()
      .post("/project_list/project/dublicate_entrance/", body, { params })
      .then((res) => res?.data);
  },
  async hasGrant(grant_code) {
    return await instance()
      .get("/project_list/project/has_grant/", { params: { grant_code } })
      .then((res) => res?.data);
  },
  async transferProject(body, params) {
    return await instance()
      .post("/project_list/project/transfer/", body, { params })
      .then((res) => res?.data);
  },
  async deleteShellProjectPerfomancer(body) {
    return await instance()
      .post(`/project_list/project/assign_del/`, body)
      .then((res) => res?.data);
  },
  async changeProjectStatus(project_id, params) {
    return await instance()
      .post(
        `/project_list/project/${project_id}/change_status/`,
        {},
        { params }
      )
      .then((res) => res?.data);
  },
  async getProjectStatusForChange() {
    return await instance()
      .get("/project_list/common/project_status/for_change/read/")
      .then((res) => res?.data);
  },
  async changeProjectStatusById(body, params) {
    return await instance()
      .post("/project_list/project/status/change/", body, { params })
      .then((res) => res?.data);
  },
  async fillEntranceFlats(project_id, params) {
    return await instance()
      .post(`/project_list/project/${project_id}/fill_flat/`, {}, { params })
      .then((res) => res?.data);
  },
  async getWarranty(body) {
    return await instance()
      .post(`/project_list/project/warranty/`, body)
      .then((res) => res?.data);
  },
  async generateDoc(body) {
    return await instance()
      .post(`project_list/project/agreement_add/`, body)
      .then((res) => res?.data);
  },
  async downloadDoc(body) {
    return await instance()
      .post(`project_list/project/get_signed_agreement/`, body)
      .then((res) => res?.data);
  },
  async deleteDoc(project_agreement_id) {
    return await instance()
      .delete(`/project_list/project/agreement_del/${project_agreement_id}/`)
      .then((res) => res?.data);
  },
  async putSBSProject(body) {
    return await instance()
      .post(`/project_list/contractors/sbs_project/get/`, body)
      .then((res) => res?.data);
  },
  async getAvailableEntrances(params) {
    return await instance()
      .get("/project_list/common/entrances/read/", { params })
      .then((res) => res?.data);
  },
  async getList(params = {}) {
    return await instance()
      .get("/project_list/project/groups/read/", { params })
      .then((res) => res?.data);
  },
  async getResidents() {
    return await instance()
      .get("/common/residents/read/")
      .then((res) => res?.data);
  },
  async updateProjectEntrance(body, params) {
    return await instance()
      .post("/project_list/project/entrance/", body, { params })
      .then((res) => res?.data);
  },
  async getEntrances(resident_id, params) {
    return await instance()
      .get(`project_list/common/residents/${resident_id}/entrances/read/`, {
        params,
      })
      .then((res) => res?.data);
  },
  async getResidentDetailedInfo(params, requestConfig = {}) {
    return await instance()
      .get(`/project_list/project/read/`, { params, ...requestConfig })
      .then((res) => res?.data);
  },
  async setProjectIsPreorder(body) {
    return await instance()
      .post("/project_list/project/is_preorder/set/", body)
      .then((res) => res?.data);
  },
  async setProjectIsSmetaConfirm(body) {
    return await instance()
      .post("/project_list/project/is_smeta_confirm/set/", body)
      .then((res) => res?.data);
  },
  async getProjectSmeta(project_id) {
    return await instance()
      .get(`/project_list/project/read/material_smeta/${project_id}/`)
      .then((res) => res?.data);
  },
  async getProjectEntranceSmeta(project_id, entrance) {
    return await instance()
      .get(
        `/project_list/project/read/material_smeta/${project_id}/${entrance}`
      )
      .then((res) => res?.data);
  },
  async getProjectFloorSmeta(project_id, entrance, floor) {
    return await instance()
      .get(
        `/project_list/project/read/material_smeta/${project_id}/${entrance}/${floor}`
      )
      .then((res) => res?.data);
  },
  async updateProjectMaterial(body) {
    return await instance()
      .post(`/project_list/project/material_purchase_upd/`, body)
      .then((res) => res?.data);
  },
  async getProjectMaterials(project_id) {
    return await instance()
      .get(`/project_list/project/read_material/${project_id}/`)
      .then((res) => res?.data);
  },
  async getResortMaterials(project_id) {
    return await instance()
      .get(`/project_list/project/resort_materials/${project_id}/`)
      .then((res) => res?.data);
  },
  async resortMaterialSearch(params = {}) {
    return await instance()
      .get('/project_list/project/resort_material_search/', { params })
      .then((res) => res?.data);
  },
  async resortMaterialUpd(body) {
    return await instance()
      .post('/project_list/project/resort_material_upd/', body)
      .then((res) => res?.data);
  },
  async getProjectEntrances(project_id) {
    return await instance()
      .get(`project_list/project/read_entrance/${project_id}/`)
      .then((res) => res?.data);
  },
  async getProjectEntranceFloors(project_id, entrance) {
    return await instance()
      .get(`project_list/project/read_floor/${project_id}/${entrance}`)
      .then((res) => res?.data);
  },
  async addProjectFloor(body) {
    return await instance()
      .post(`/project_list/project/floor/add/`, body)
      .then((res) => res?.data);
  },
  async deleteProjectFloor(floor_map_id, params) {
    return await instance()
      .delete(`/project_list/project/floor/${floor_map_id}/delete/`, { params })
      .then((res) => res?.data);
  },
  async getProjectList(params = {}) {
    return await instance()
      .get("/project_list/project/read/", { params })
      .then((res) => res?.data);
  },
  async getProjectsForTransfer(project_id, params = {}) {
    return await instance()
      .get(`/project_list/project/read_for_transfer/${project_id || ""}/`, { params })
      .then((res) => res?.data);
  },
  async copyFloorToProject(floor_map_id, body = {}) {
    return await instance()
      .post(`/project_list/floor_map/${floor_map_id}/copy_to_project/`, body)
      .then((res) => res?.data);
  },
  async updateWorksetProject(body) {
    return await instance()
      .post(`/project_list/project/material_upd/`, body)
      .then((res) => res?.data);
  },
  async recalcSmeta(project_id, reason_code, comments = null) {
    return await instance()
      .post(`/project_list/project/recalc_smeta/${project_id}/`, {
        reason_code,
        comments,
      })
      .then((res) => res?.data);
  },
  async getSmetaChangeReasons() {
    return await instance()
      .get(`/project_list/project/smeta_change_reason/`)
      .then((res) => res?.data);
  },
  async getSmetaVersions(project_id) {
    return await instance()
      .get(`/project_list/project/smeta_versions/${project_id}/`)
      .then((res) => res?.data);
  },
  async getSmetaDiffWork(
    project_id,
    smeta_version_id1,
    smeta_version_id2,
    extraParams = {}
  ) {
    const { entrance, level_num } = extraParams || {};
    return await instance()
      .get(`/project_list/project/smeta_diff_work/${project_id}/`, {
        params: {
          smeta_version_id1,
          smeta_version_id2,
          entrance,
          level_num,
        },
      })
      .then((res) => res?.data);
  },
  async getSmetaDiffMaterial(
    project_id,
    smeta_version_id1,
    smeta_version_id2,
    extraParams = {}
  ) {
    const { entrance, level_num } = extraParams || {};
    return await instance()
      .get(`/project_list/project/smeta_diff_material/${project_id}/`, {
        params: {
          smeta_version_id1,
          smeta_version_id2,
          entrance,
          level_num,
        },
      })
      .then((res) => res?.data);
  },
  async getSmetaCompareNewReport(project_id, params) {
    return await instance()
      .get(`/project_list/project/smeta_compare_new_report/${project_id}/`, { params })
      .then((res) => res?.data);
  },
  async getSmetaAgreementVersions(project_id) {
    return await instance()
      .get(`/project_list/project/smeta_agreement_versions/${project_id}/`)
      .then((res) => res?.data);
  },
  async getSmetaAgreementHistoryCompare(project_id, params) {
    return await instance()
      .get(`/project_list/project/smeta_agreement_history_compare/${project_id}/`, { params })
      .then((res) => res?.data);
  },
  async getSmetaRestoreCompare(project_id, params) {
    return await instance()
      .get(`/project_list/project/smeta_restore_compare/${project_id}/`, { params })
      .then((res) => res?.data);
  },
  async postSmetaRestoreCompareUpd(project_id, body) {
    return await instance()
      .post(`/project_list/project/smeta_restore_compare_upd/${project_id}/`, body)
      .then((res) => res?.data);
  },
  async getProjectDocs(params) {
    return await instance()
      .get(`/project_list/project/document/read/`, { params })
      .then((res) => res?.data);
  },
  async getProjectDocTypes() {
    return await instance()
      .get(`/project_list/project/document_type/read/`)
      .then((res) => res?.data);
  },
  async addProjectDocument(body, project_id) {
    const formData = new FormData();
    formData.append("project_id", project_id);

    Object.keys(body).forEach((key) => {
      if (key === "project_document_id" && !body[key]) {
        return;
      }
      if (body[key] !== null && body[key] !== undefined) {
        formData.append(key, body[key]);
      }
    });

    return await instance()
      .post(`/project_list/project/document/upd/`, formData, {
        params: { project_id },
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => res?.data);
  },
  async signDocument(body) {
    return await instance()
      .post(`/project_list/project/document/sign/`, body)
      .then((res) => res?.data);
  },
  async deleteDocument(project_document_id, params) {
    return await instance()
      .delete(`/project_list/project/document_del/${project_document_id}/`, {
        params,
      })
      .then((res) => res?.data);
  },
  async loadRevitProject(body) {
    return await instance()
      .post(`/project_list/project/load_revit/`, body)
      .then((res) => res?.data);
  },
  async getBimDigitalParamCompare(params) {
    return await instance()
      .get(`/project_list/project/bim_digital_param_compare/`, { params })
      .then((res) => res?.data);
  },
  async getDigitalSmetaCompare(params) {
    return await instance()
      .get(`/project_list/project/digital_smeta_compare/`, { params })
      .then((res) => res?.data);
  },
  async getEntrancesByProject(params) {
    return await instance()
      .get(`/project/entrances/by_project/`, { params })
      .then((res) => res?.data);
  },
  async getSbsProjectList() {
    return await instance()
      .get(`/project/sbs_project/read_list/`)
      .then((res) => res?.data);
  },
  async getSbsProjectListForModal() {
    return await instance()
      .get(`/project/sbs_project/read_for_modal/`)
      .then((res) => res?.data);
  },
  async getProjectSmetaNew(params) {
    return await instance()
      .get(`/project_list/project/smeta_new_report/`, { params })
      .then((res) => res?.data);
  },
  async getResidentSmetaNew(params) {
    return await instance()
      .get(`/project_list/project/smeta_resident_new_report/`, { params })
      .then((res) => res?.data);
  },
  async getResidentSmetaUsp(params) {
    return await instance()
      .get(`/project_list/project/smeta_resident_usp_report/`, { params })
      .then((res) => res?.data);
  },
  async exportResidentSmetaNew(params) {
    return await instance()
      .get(`/project_list/project/smeta_resident_new_report/excel/`, { params, responseType: 'blob' })
      .then((res) => res?.data);
  },
  async exportResidentSmetaUsp(params) {
    return await instance()
      .get(`/project_list/project/smeta_resident_usp_report/excel/`, { params, responseType: 'blob' })
      .then((res) => res?.data);
  },
  async getUspMaterialsNds(params) {
    return await instance()
      .get(`/project_list/project/usp_materials_nds_report/`, { params })
      .then((res) => res?.data);
  },
  async getUspNdsAvrYearReport(params = {}) {
    return await instance()
      .get(`/project_list/project/usp_nds_avr_year_report/`, { params })
      .then((res) => res?.data);
  },
  async exportUspMaterialsNds(params) {
    return await instance()
      .get(`/project_list/project/usp_materials_nds_report/excel/`, { params, responseType: 'blob' })
      .then((res) => res?.data);
  },
  async getEntranceFloors(params) {
    return await instance()
      .get(`/project_list/common/entrance_floors/read/`, { params })
      .then((res) => res?.data);
  },
  async getFloorMapByEntrance(params) {
    return await instance()
      .get(`/project/floor_map/read/`, { params })
      .then((res) => res?.data);
  },
  async getProjectSmetaHistory(params) {
    return await instance()
      .get(`/project_list/project/smeta_history_report/`, { params })
      .then((res) => res?.data);
  },
  async updateSmetaNewWorkQty(body) {
    return await instance()
      .post(`/project_list/project/smeta_new/update_work_qty/`, body)
      .then((res) => res?.data);
  },
  async updateSmetaNewMaterialQty(body) {
    return await instance()
      .post(`/project_list/project/smeta_new/update_material_qty/`, body)
      .then((res) => res?.data);
  },
  async getSmetaNewWorkSetsByGroup(params) {
    return await instance()
      .get(`/project_list/project/smeta_new/work_sets_by_group/`, { params })
      .then((res) => res?.data);
  },
  async getSmetaNewAvrList(params) {
    return await instance()
      .get(`/project_list/project/smeta_new/avr_list/`, { params })
      .then((res) => res?.data);
  },
  async getSmetaNewMaterialSearch(params) {
    return await instance()
      .get(`/project_list/project/smeta_new/material_search/`, { params })
      .then((res) => res?.data);
  },
  async getSmetaNewRefreshPricesPreview(params) {
    return await instance()
      .get(`/project_list/project/smeta_new/refresh_prices_preview/`, { params })
      .then((res) => res?.data);
  },
  async getSmetaNewRefreshSmrScope(params) {
    return await instance()
      .get(`/project_list/project/smeta_new/refresh_smr_scope/`, { params })
      .then((res) => res?.data);
  },
  async getSmetaNewRefreshTmcPricesPreview(params) {
    return await instance()
      .get(`/project_list/project/smeta_new/refresh_tmc_prices_preview/`, { params })
      .then((res) => res?.data);
  },
  async getSmetaNewFloorsForCopy(params) {
    return await instance()
      .get(`/project_list/project/smeta_new/floors_for_copy/`, { params })
      .then((res) => res?.data);
  },
  async getSmetaNewAvailableGroups(params) {
    return await instance()
      .get(`/project_list/project/smeta_new/available_groups/`, { params })
      .then((res) => res?.data);
  },
  async getSmetaNewWorkSetsInScope(params) {
    return await instance()
      .get(`/project_list/project/smeta_new/work_sets_in_scope/`, { params })
      .then((res) => res?.data);
  },
  async getSmetaNewNdsPercent() {
    return await instance()
      .get(`/project_list/project/smeta_new/nds_percent/`)
      .then((res) => res?.data);
  },
  async getProjectState(project_id) {
    return await instance()
      .get(`/project_list/project/state/`, { params: { project_id } })
      .then((res) => res?.data);
  },
  async saveSmetaNewChanges(body) {
    return await instance()
      .post(`/project_list/project/smeta_new/save_changes/`, body)
      .then((res) => res?.data);
  },
  async getProjectSmetaMaterialReport(params) {
    return await instance()
      .get(`/project_list/project/smeta_material_report/`, { params })
      .then((res) => res?.data);
  },
  async getSmetaAnomalies(params) {
    return await instance()
      .get(`/project_list/project/smeta_anomalies/`, { params })
      .then((res) => res?.data);
  },
  async createDS(body) {
    return await instance()
      .post(`/project_list/project/ds_add/`, body)
      .then((res) => res?.data);
  },
  async dduDownload(params) {
    return await instance().get("/project_list/common/ddu/download/", {
      params,
      responseType: "blob",
      _skipErrorToast: true,
    });
  },
  async agreementCancel(body) {
    return await instance()
      .post(`/project_list/project/agreement_cancel/`, body)
      .then((res) => res?.data);
  },
  async duplicateProjectAssign(body) {
    return await instance()
      .post(`/project/assign_dublicate/`, body)
      .then((res) => res?.data);
  },
};
